import { formatDatetime } from '../format/formatDatetime'
import { typeEmpty } from '../type/typeEmpty'

/**
 * @desc 验证是否dateTime格式
 * @param {Boolean} required
 * @param {String} validateValue
 * @param {*} callback
 * @param {String} field
 * @param {String} [action]
 */
export const vDatetime = (required: boolean, validateValue: string, callback: any, field: string = '时间', action: string = '填写'): void => {
  if (!required && !validateValue) {
    callback()
  } else {
    if (typeEmpty(validateValue)) {
      action = action || '填写'
      callback(new Error(`${field}必须${action}`))
    } else {
      if (formatDatetime(validateValue)) {
        callback()
      } else {
        callback(new Error(`${field}格式不正确`))
      }
    }
  }
}
